import { useMemo } from "react";
import { Helmet } from "react-helmet";

const SiteTitle = ({ title }: { title?: string }) => {
  const newTitle = useMemo(() => {
    if (!title) {
      return "国投幸福家";
    }
    return `${title}-国投幸福家`;
  }, [title]);

  return (
    <Helmet>
      <title>{newTitle}</title>
      <meta name="description" content={newTitle} />
    </Helmet>
  );
};
export default SiteTitle;
